import * as Api from '@ViewModels';
import moment from 'moment';
import { OPPORTUNITY_REPORTING_UNASSIGNED_OWNER_VALUE } from './opportunityReportingConstants';

export type OpportunityReportingOwnerScope = 'any' | 'unassigned' | 'specific';

export function buildOpportunityReportingApiFilter(input: {
	boardId?: string;
	includeArchived: boolean;
	filterStageId: string;
	ownerScope: OpportunityReportingOwnerScope;
	specificOwnerUserId: string;
	creationDateFrom: string;
	creationDateTo: string;
	closeDateFrom: string;
	closeDateTo: string;
}): Api.IOpportunityReportingFilterRequest {
	const criteria: Api.IOpportunityReportingFilterCriteria[] = [];

	if (input.filterStageId) {
		criteria.push({
			property: Api.OpportunityReportingFilterProperty.PipelineStage,
			value: input.filterStageId,
		});
	}

	if (input.ownerScope === 'unassigned') {
		criteria.push({
			property: Api.OpportunityReportingFilterProperty.Owner,
			value: OPPORTUNITY_REPORTING_UNASSIGNED_OWNER_VALUE,
		});
	} else if (input.ownerScope === 'specific' && input.specificOwnerUserId) {
		criteria.push({
			property: Api.OpportunityReportingFilterProperty.Owner,
			value: input.specificOwnerUserId,
		});
	}

	if (input.creationDateFrom) {
		criteria.push({
			property: Api.OpportunityReportingFilterProperty.CreationDate,
			op: Api.FilterOperator.Gt,
			value: moment(input.creationDateFrom).startOf('day').toISOString(),
		});
	}
	if (input.creationDateTo) {
		criteria.push({
			property: Api.OpportunityReportingFilterProperty.CreationDate,
			op: Api.FilterOperator.Lt,
			value: moment(input.creationDateTo).endOf('day').toISOString(),
		});
	}

	if (input.closeDateFrom) {
		criteria.push({
			property: Api.OpportunityReportingFilterProperty.CloseDate,
			op: Api.FilterOperator.Gt,
			value: moment(input.closeDateFrom).startOf('day').toISOString(),
		});
	}
	if (input.closeDateTo) {
		criteria.push({
			property: Api.OpportunityReportingFilterProperty.CloseDate,
			op: Api.FilterOperator.Lt,
			value: moment(input.closeDateTo).endOf('day').toISOString(),
		});
	}

	return {
		...(input.boardId !== undefined ? { boardId: input.boardId } : {}),
		includeArchived: input.includeArchived,
		...(criteria.length > 0 ? { criteria } : {}),
	};
}
